export default "<svg viewBox=\"0 0 24 24\">\n        <circle cx=\"11\" cy=\"12\" r=\"11\" />\n      </svg>";